export enum OrderStatus {
    NOTHING = 'NOTHING',
    IN_PROGRESS = 'IN_PROGRESS',
    SUBMITTED = 'SUBMITTED',
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
    FAIL_INTERNAL_SERVER = 'FAIL_INTERNAL_SERVER', // Client side network issue, server down could cause this issue
    BAD_REQUEST = 'BAD_REQUEST'
}
